export default __webpack_public_path__ + "static/media/ticket-available.53c66ef5.svg";